import sharedConstants from "@lib/shared_constants";

const IMPORT_TYPES = sharedConstants.USER_CSV_IMPORT.CSV_IMPORT_TYPES;
export type CsvImportType = (typeof IMPORT_TYPES)[keyof typeof IMPORT_TYPES];

export type ValidationStatus = "in_progress" | "completed" | "timed_out" | "skipped" | "cancelled";

export interface ValidationSummary {
  blocking_error_count: number;
  non_blocking_error_count: number;
  rows_checked: number;
}

export interface GetAppsAppGroupIdUserImportsImportIdResult {
  id: string;
  start_time: number;
  name: string;
  total_rows: number;
  total_record_count?: number | null;
  import_count: number;
  malformed_count: number;
  no_id_count: number;
  is_done: boolean;
  segment_id: string | null;
  cancelled: boolean;
  download_link: string | null;
  error_report_download_link: string | null;
  has_error_report: boolean;
  is_uploaded_by_current_developer: boolean;
  validation_report_download_link: string | null;
  validation_started_at: number | null;
  validation_status: ValidationStatus | null;
  validation_summary: Partial<ValidationSummary>;
  should_make_filterable: boolean;
  import_type: CsvImportType;
  has_hit_user_limit: boolean;
  failed: boolean;
  developer: string | null;
}

export type ImportStatus = GetAppsAppGroupIdUserImportsImportIdResult;
